import { useEffect, useRef } from 'react';

import { useAutoUpdatedRef } from './useAutoUpdatedRef';

export function useClickAway<T extends HTMLElement>(cb: (event: MouseEvent | TouchEvent) => unknown) {
  const ref = useRef<T | null>(null);
  const refCb = useAutoUpdatedRef(cb);

  useEffect(() => {
    const handler = (e: MouseEvent | TouchEvent) => {
      const element = ref.current;

      if (element && !element.contains(e.target as Node)) {
        refCb.current?.(e);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [refCb]);

  return ref;
}
